// src/app/directives/bootstrap-select.directive.ts
import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges
} from '@angular/core';
declare const $: any;

@Directive({ selector: '[bootstrapSelect]' })
export class BootstrapSelectDirective implements AfterViewInit, OnChanges {
  /** opções do select */
  @Input() bootstrapSelect: any[] = [];
  /** valor do ngModel */
  @Input() bootstrapSelectModel: any;
  /** estado disabled */
  @Input() bootstrapDisabled: boolean = false;

  private $el: any;

  constructor(private el: ElementRef) {
    this.$el = $(this.el.nativeElement);
  }

  ngAfterViewInit() {
    // Inicializa o selectpicker
    this.$el.selectpicker();

    // Fecha o dropdown ao selecionar
    this.$el.on('changed.bs.select', () => {
      this.$el.parent().removeClass('open');
    });

    // Aplicar estado inicial e valor
    this.updatePicker();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Sempre que opções, modelo ou disabled mudarem
    if (
      changes['bootstrapSelect'] ||
      changes['bootstrapSelectModel'] ||
      changes['bootstrapDisabled']
    ) {
      this.updatePicker();
    }
  }

  private updatePicker() {
    // 1) Ajusta disabled no <select>
    this.$el.prop('disabled', this.bootstrapDisabled);

    // 2) Define o valor selecionado (garante que o tipo bate)
    this.$el.selectpicker('val', this.bootstrapSelectModel);

    // 3) Re-renderiza / fecha corretamente
    this.$el.selectpicker('refresh');
  }
}
